export default __webpack_public_path__ + "static/media/pic2.7c30f12b.jpg";